import Arrows from "../Arrows";

/**
 * Renders arrows for a group of cards
 */
export default function GroupArrows({ cards, groups }) {
  const edges = Object.keys(groups).map(groupId => {
    const group = groups[groupId];
    const groupEdges = [];

    group.cards.forEach((cardId, i) => {
      if (i === 0) {
        return;
      }

      const prevCardId = group.cards[i - 1];
      const currCardId = group.cards[i];

      groupEdges.push({
        fromCard: prevCardId,
        toCard: currCardId,
      });
    });

    return groupEdges;
  }).flat();

  return (
    <Arrows edges={edges} cards={cards} />
  );
}
